import { statsData } from '@/mocks/manga';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-400 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-background-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}